import * as Sentry from '@sentry/react';
import { UserModel } from '../models';

class SentryService {
  /**
   * Set user context for Sentry
   */
  setUser(user: Partial<UserModel> | null): void {
    if (user) {
      const { id, code, role } = user;

      Sentry.setUser({ id, code, role });
      return;
    }

    Sentry.setUser(null);
  }

  /**
   * Manually capture an exception to Sentry
   */
  captureException(error: Error, context?: Record<string, any>): void {
    if (context) {
      Sentry.withScope((scope) => {
        Object.keys(context).forEach((key) => {
          scope.setExtra(key, context[key]);
        });
        Sentry.captureException(error);
      });
    } else {
      Sentry.captureException(error);
    }
  }

  /**
   * Manually capture a message to Sentry
   */
  captureMessage(message: string, level: Sentry.SeverityLevel = 'info'): void {
    Sentry.captureMessage(message, level);
  }

  /**
   * Add breadcrumb for better error context
   */
  addBreadcrumb(message: string, data?: Record<string, any>): void {
    Sentry.addBreadcrumb({
      message,
      data,
      level: 'info',
    });
  }

  /**
   * Set custom tag for filtering errors
   */
  setTag(key: string, value: string): void {
    Sentry.setTag(key, value);
  }

  /**
   * Set custom context
   */
  setContext(name: string, context: Record<string, any>): void {
    Sentry.setContext(name, context);
  }
}

const sentryService = new SentryService();

export default sentryService;
